
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiservicechakanpune() {



    const cardData =
    {
        keyword: 'Taxi Service in Chakan Pune',
        heading: 'Platinum24 Cabs: Taxi Service in Chakan Pune',
        headingDescription: ' Platinum24 Cabs offers reliable Taxi Service in Chakan Pune, catering to the needs of residents, industrial professionals, and business travelers in this growing hub. Our fleet of hatchbacks, sedans, SUVs, and luxury cars provides safe, clean, and comfortable rides for local commutes, airport transfers, and outstation travel. With professional chauffeurs, punctual pickups, and transparent pricing, we ensure stress-free travel experiences in and around Chakan. Whether it’s a corporate transfer, a factory visit, or a family outing, Platinum24 Cabs guarantees 24/7 availability, affordable fares, and dependable taxi services in Chakan Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


           "services": [
    {
      "name": "Chakan Taxi Service",
      "description": "Our Chakan Taxi Service offers reliable and comfortable transportation across Chakan and nearby areas. Whether for daily commutes, business trips, or leisure travel, enjoy professional drivers, well-maintained vehicles, and timely pickups to make every journey smooth and stress-free."
    },
    {
      "name": "Taxi Booking Chakan Pune",
      "description": "Easily book your taxi in Chakan Pune through our user-friendly online platform or phone service. With instant confirmation, multiple vehicle options, and 24x7 availability, your cab booking experience is designed for convenience and flexibility."
    },
    {
      "name": "Cab Service Chakan Pune",
      "description": "Our Cab Service in Chakan Pune provides affordable and efficient transportation solutions for all your travel needs. From local rides to outstation trips, our cabs are available round the clock to ensure you reach your destination safely and on time."
    },
    {
      "name": "Chakan Local Taxi",
      "description": "For all local travel within Chakan, our Local Taxi service offers convenient, affordable, and timely rides. Ideal for work commutes, shopping, and errands, enjoy hassle-free city travel with courteous drivers and clean vehicles."
    },
    {
      "name": "Affordable Taxi Chakan Pune",
      "description": "Choose our Affordable Taxi service in Chakan Pune to enjoy budget-friendly rates without compromising on quality or comfort. Perfect for daily travelers and families looking for economical yet reliable cab options."
    },
    {
      "name": "Chakan Taxi with Driver",
      "description": "Travel safely and comfortably with our Chakan Taxi service that includes professional drivers. Our experienced chauffeurs know the best routes and ensure punctuality, courteous service, and a smooth ride every time."
    },
    {
      "name": "Chakan Airport Taxi",
      "description": "Make your airport transfers seamless with our Chakan Airport Taxi service. Available 24x7, we offer timely pickups and drop-offs to Pune Airport and other nearby airports, ensuring you never miss a flight or face delays."
    },
    {
      "name": "Taxi Service Near Me Chakan",
      "description": "Find the best taxi services near you in Chakan quickly and easily. Our extensive network guarantees prompt cab dispatch and reliable service wherever you are located in the area."
    },
    {
      "name": "Chakan Outstation Taxi",
      "description": "Plan your outstation trips conveniently with our Chakan Outstation Taxi service. Whether it’s a weekend getaway or business travel, we provide comfortable vehicles and experienced drivers to take you safely to your destination."
    },
    {
      "name": "Chakan Corporate Taxi Service",
      "description": "Our Corporate Taxi Service in Chakan caters to business clients requiring professional, timely, and flexible transportation for employees, clients, and events. Customized packages and dedicated support ensure smooth corporate travel experiences."
    },
    {
      "name": "Chakan Cab Rental",
      "description": "Rent a cab in Chakan for short or long durations with our flexible Cab Rental service. Ideal for group outings, corporate events, and special occasions, our rental packages come with competitive pricing and professional drivers."
    },
    {
      "name": "Chakan City Taxi",
      "description": "Explore Chakan city conveniently with our City Taxi service. Whether for sightseeing, shopping, or meetings, our reliable cabs and knowledgeable drivers help you navigate the city efficiently and comfortably."
    },
    {
      "name": "Chakan Taxi Deals",
      "description": "Benefit from exclusive Chakan Taxi Deals featuring discounted rates on rides, special offers on airport transfers, and outstation packages. Save more while enjoying premium taxi services."
    },
    {
      "name": "Chakan Family Taxi Service",
      "description": "Travel with your family safely and comfortably using our Family Taxi Service in Chakan. Spacious vehicles, child safety features, and courteous drivers make family outings and daily travel convenient and worry-free."
    },
    {
      "name": "Chakan Taxi Booking Online",
      "description": "Book your Chakan taxi online anytime with our secure and easy-to-use platform. Get instant confirmations, manage your bookings effortlessly, and access 24x7 customer support for all your taxi service needs."
    }
  ],
  "tableData": [
    ["Chakan Taxi Service", "Taxi Booking Chakan Pune"],
    ["Cab Service Chakan Pune", "Chakan Local Taxi"],
    ["Affordable Taxi Chakan Pune", "Chakan Taxi with Driver"],
    ["Chakan Airport Taxi", "Taxi Service Near Me Chakan"],
    ["Chakan Outstation Taxi", "Chakan Corporate Taxi Service"],
    ["Chakan Cab Rental", "Chakan City Taxi"],
    ["Chakan Taxi Deals", "Chakan Family Taxi Service"],
    ["Chakan Taxi Booking Online", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Taxi Service in Chakan Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers prompt and efficient taxi services throughout Chakan for all your commuting needs."
    },
    {
      "WhyChooseheading": "Quick Pickup with Nearby Drivers",
      "WhyChoosedescription": "Our drivers are strategically located in Chakan to ensure fast and convenient pickups."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned taxis that prioritize your comfort and safety."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Local Routes",
      "WhyChoosedescription": "Our professional drivers know Chakan and surrounding areas well to provide smooth and timely rides."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy upfront pricing with no hidden charges, covering fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings and travel inquiries."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
      "WhyChoosedescription": "Choose from point-to-point rides, hourly rentals, or long-distance trips based on your needs."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Choices to Suit Your Group Size",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or larger vehicles depending on your comfort and luggage requirements."
    }
  ]
























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide taxi services in Chakan, Pune?',
        answer: 'Yes, Platinum24 Cabs offers reliable and efficient taxi services in Chakan, Pune for both local and outstation travel.',
    },
    {
        question: 'How can I book a taxi service in Chakan Pune with Platinum24 Cabs?',
        answer: 'You can book your taxi easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for taxi service in Chakan Pune?',
        answer: 'We provide a wide range of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
    },
    {
        question: 'Can I book taxis for local travel as well as outstation trips from Chakan?',
        answer: 'Yes, we offer both local taxi services within Chakan and outstation trips to destinations across Maharashtra and beyond.',
    },
    {
        question: 'Are your taxi drivers experienced and familiar with Chakan routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and well-acquainted with Chakan and surrounding areas for safe and timely travel.',
    },
    {
        question: 'Can I hire a taxi on an hourly basis in Chakan?',
        answer: 'Yes, hourly rental packages are available for local taxi hire in Chakan.',
    },
    {
        question: 'Are safety and hygiene protocols followed for taxi services in Chakan?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety measures to ensure passenger protection.',
    },
    {
        question: 'Is taxi service in Chakan available 24x7?',
        answer: 'Yes, Platinum24 Cabs provides 24x7 taxi service bookings in Chakan for your convenience.',
    },
    {
        question: 'What payment options are accepted for taxi bookings in Chakan?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for seamless transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Chakan?',
        answer: 'Yes, you can specify any pickup and drop-off points within Chakan as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rahul Deshmukh',
        feedback: 'Booked a taxi in Chakan through Platinum24 Cabs. The driver was professional and the ride was comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priyanka Kulkarni',
        feedback: 'Excellent service for local taxi in Chakan. Easy booking and timely pickups.',
        rating: 5,
    },
];































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const chakanTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable taxi service in Chakan Pune offering local, airport, outstation, corporate, and family taxi services with professional drivers.",
  "areaServed": {
    "@type": "Place",
    "name": "Chakan, Pune"
  },
  "serviceType": [
    "Chakan Taxi Service",
    "Taxi Booking Chakan Pune",
    "Cab Service Chakan Pune",
    "Chakan Local Taxi",
    "Affordable Taxi Chakan Pune",
    "Chakan Taxi with Driver",
    "Chakan Airport Taxi",
    "Taxi Service Near Me Chakan",
    "Chakan Outstation Taxi",
    "Chakan Corporate Taxi Service",
    "Chakan Cab Rental",
    "Chakan City Taxi",
    "Chakan Taxi Deals",
    "Chakan Family Taxi Service",
    "Chakan Taxi Booking Online"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>

<Helmet>
  <title>Taxi Service in Chakan Pune | Affordable Cab Booking Chakan Pune</title>
  <meta
    name="description"
    content="Reliable and affordable taxi service in Chakan Pune offering local, airport, outstation, corporate, and family taxi services with professional drivers."
  />
  <meta
    name="keywords"
    content="Chakan Taxi Service, Taxi Booking Chakan Pune, Cab Service Chakan Pune, Chakan Local Taxi, Affordable Taxi Chakan Pune, Chakan Taxi with Driver, Chakan Airport Taxi, Taxi Service Near Me Chakan, Chakan Outstation Taxi, Chakan Corporate Taxi Service, Chakan Cab Rental, Chakan City Taxi, Chakan Taxi Deals, Chakan Family Taxi Service, Chakan Taxi Booking Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(chakanTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Taxiservicechakanpune;